var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-y-4"},[_c('AssetTile',{attrs:{"without-actions":"","asset":_vm.asset}}),_c('div',{staticClass:"text-center"},[_c('BaseButton',{attrs:{"primary":"","small":"","disabled":_vm.pending},on:{"click":_vm.addAsset}},[(_vm.pending)?_c('Loader',{attrs:{"small":"","inverse":""}}):[_vm._v(" Add ")]],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }